import React from 'react'
import PropTypes from 'prop-types'
import { withQueryParams } from 'utils/router'
import Onboarding from 'components/Auth/Onboarding'

const OnboardingPage = ({ match, queryParams }) => (
  <Onboarding
    plan={queryParams.plan}
    coupon={queryParams.coupon}
    jwtData={match.params.jwtData}
  />
)

OnboardingPage.propTypes = {
  match: PropTypes.object.isRequired,
  queryParams: PropTypes.object.isRequired,
}

export default withQueryParams(OnboardingPage)
